const gtmUtil = props => {
  const category = props.category || ''
  const action = props.action || ''
  const label = props.label || ''
  const event = props.event || 'trackCmtToProgrammerCui'

  // console.log(category, action, label, event)
  // console.log(window.dataLayer)

  const dataLayer = window.dataLayer || []
  dataLayer.push({
    eventCategory: category,
    eventAction: action,
    eventLabel: label,
    event: event,
  })
}
export default gtmUtil
